import React from 'react';
import PropTypes from 'prop-types';
import useForm from '@afosto/utils-react/validation/useForm';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Form from '@afosto/app-components-react/Form';
import Select from '@afosto/app-components-react/Select';
import translations from './translations';

const ProcessForm = ({ process, onCancel, onSubmit }) => {
  const intl = useIntl();
  const form = useForm({
    defaultValues: {
      allocation: process?.allocation ?? 'auto',
      confirm: process?.confirm ?? 'auto',
      capture: process?.capture ?? 'auto',
      fulfilment: process?.fullscreen ?? 'auto',
    },
    onSubmit,
    onCancel,
  });

  const processingOptions = [
    {
      label: intl.formatMessage(translations.processingOptions.auto),
      value: 'auto',
    },
    {
      label: intl.formatMessage(translations.processingOptions.manual),
      value: 'manual',
    },
    {
      label: intl.formatMessage(translations.processingOptions.none),
      value: 'none',
    },
  ];

  return (
    <Form form={form}>
      <Select
        name="allocation"
        label={intl.formatMessage(translations.fields.allocation)}
        suggestions={processingOptions}
      />

      <Select
        name="confirm"
        label={intl.formatMessage(translations.fields.confirm)}
        suggestions={processingOptions.filter(option => option.value !== 'none')}
      />

      <Select
        name="capture"
        label={intl.formatMessage(translations.fields.capture)}
        suggestions={processingOptions}
      />

      <Select
        name="fulfilment"
        label={intl.formatMessage(translations.fields.fulfilment)}
        suggestions={processingOptions}
      />
    </Form>
  );
};

ProcessForm.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  process: PropTypes.object,
};

ProcessForm.defaultProps = {
  onCancel: undefined,
  onSubmit: undefined,
  process: {},
};

export default ProcessForm;
